import { buttonActionFunc } from "./common/_buttonAction";
import { headerFunc } from "./common/_header";
import { footerFunc } from "./common/_footer";
import singleColumn from "./common/_singleColumn";
import { commonFunc } from "./common/_common";
import { homeFunc } from "./pages/_home";

addEventListener("DOMContentLoaded", () => {
  headerFunc();
  footerFunc();
  if (document.querySelector('.single-post_column') !== null) singleColumn();

  // スムーススクロール
  $('a[href^="#"]').on('click', function () {
    const speed = 500;
    const header = $('.site-header').innerHeight();
    const href = $(this).attr('href');
    const target = $(href == '#' || href == '' ? 'html' : href);
    const position = target.offset().top - header;
    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });

  /**
   * scroll able
   */
  const scrollAbles = document.querySelectorAll('.c-table-scroll');
  if (scrollAbles.length) {
    scrollAbles.forEach((scrollAble) => {
      const box = document.createElement('div');
      box.innerHTML = '← →<br>横スクロール可能です';
      box.classList.add('c-table-scroll__box');
      scrollAble.appendChild(box);

      scrollAble.addEventListener('scroll', () => {
        box.style.display = 'none';
      });
    });
  }
});
